import HTTP from "./http.service";
import { getAPIConfig } from "./api.service";
// import Storage from "./storage.service";
// import Settings from "./settings.service";
import { getLatLngKey } from "./helpers";
import Settings from "./settings.service";
import Storage from "./storage.service";
import { getSavedPlan } from "./plans.service";
import {
  findPlace,
  createMap,
  mapExists,
  getLatLngFromPlace,
} from "./maps.service";
import { CoverageCheckMapID } from "../static/fields.data";
import { handleError } from "./errors.service";
const fetchCoverageForPoint = (latLng) => {
  return HTTP(getAPIConfig("GET_COVERAGE", latLng));
};

const confirmCoverage = (coverage, nextAction = null) => {
  return HTTP(getAPIConfig("CONFIRM_COVERAGE", coverage));
};

const getCoverageDetails = (latLng) => {
  return HTTP(getAPIConfig("GET_COVERAGE_DETAILS", latLng));
};

const getCoverageFromPlan = (plan) => {
  let bb_id = plan["vmo_subplans_ids_by_type"]["BroadbandDevice"];
  let bb_subplan = plan["vmo_subplans"][bb_id];
  let details
  if(bb_subplan) {
     details = bb_subplan["ExtraDetails"];
  }
  if(details){
    return details["Coverage"]; // 5G, 4G
  }
  return null;
};

const createCoverageMap = () => {
  if (!mapExists(CoverageCheckMapID)) {
    createMap(CoverageCheckMapID, Storage.get("map_ref_" + CoverageCheckMapID));
  }
};

const getCoverageOptions = (plans) => {
  let coverages = [];
  for (let plan of plans) {
    coverages.push(getCoverageFromPlan(plan));
  }
  return coverages;
};

const getPlaceCoordinatesFromSavedPlan = () => {
  let saved_plan = Storage.get("saved_plan");
  if (saved_plan && saved_plan["Location"]) {
    return {
      lat: saved_plan["Location"].Latitude,
      lng: saved_plan["Location"].Longitude,
    };
  }
  return null;
};

const getCoveragePlace = () => {
  let coverage_place = Storage.get("map_" + CoverageCheckMapID + "_last_place");
  return coverage_place;
};

const getCoverageData = () => {
  // let markerLatLng = getCoveragePlaceLatLng();
  // if (markerLatLng) {
  //   let coverage_data = Storage.get(getLatLngKey(markerLatLng));
  //   return coverage_data;
  // }
  return Storage.get("coverage_data");
};
const getCoveragePlaceLatLng = () => {
  let coverage_place = getCoveragePlace();
  let markerLatLng = getLatLngFromPlace(coverage_place);
  return markerLatLng;
};

const findCoveragePlace = (latLng) => {
  findPlace(CoverageCheckMapID, latLng);
};

const getCoverageForLatLng = (latLng) => {
  let key = "coverage_data_" + getLatLngKey(latLng);
  let cached = Storage.get(key);

  if (cached) {
    Storage.set("coverage_data", cached);
  } else {
    fetchCoverageForPoint(latLng)
      .then((res) => {
        Storage.set(key, res.data);
        Storage.set("coverage_data", res.data);
      })
      .catch((error) => {
        // @Todo
      });
  }
};

const initializeCoverage = () => {
  createCoverageMap();
  let flags = Storage.get("flow_status_flags");
  if (flags && flags.is_plan_selected) {
    getSavedPlan()
      .then(() => {
        let latLng = getPlaceCoordinatesFromSavedPlan();

        let overrideLatLng =
          getCoveragePlaceLatLng() ||
          Storage.get("modem_latlng", Settings.save_coverage_point);
        if (overrideLatLng) {
          latLng = overrideLatLng;
        }

        Storage.set("modem_latlng", latLng);

        getCoverageForLatLng(latLng);
      })
      .catch((error) => {
        // @Todo
        handleError(error, "initializeCoverage")
      });
  } else {
    let latLng = Storage.get("modem_latlng", Settings.save_coverage_point);
    if (latLng) {
      getCoverageForLatLng(latLng);
    }
  }
};

// GET_PLANS_BY_PRODUCT code 190
// export default {};
export {
  getCoverageFromPlan,
  getCoverageOptions,
  getCoverageDetails,
  confirmCoverage,
  findCoveragePlace,
  getCoverageData,
  getCoveragePlaceLatLng,
  getCoveragePlace,
  createCoverageMap,
  fetchCoverageForPoint,
  initializeCoverage,
};
